<template>
  <div class="wrapper" style="background:#57CB4A;">
    <!-- 日历 -->
    <!-- <div class="timelineTop">
      
    </div> -->
    <!-- <calendarCard style="margin-top:1.5vw;width:50vw;" class="auto"></calendarCard> -->
    <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      
    </van-pull-refresh> -->
    <div style="color:#fff;text-align:center;margin-top:10vw;" v-if="listDataLoading">数据加载中···</div>
    <div class="listWrapper">
      <matchCard v-for="(val,index) in myList" :title="val.subject" :score="val.score" :key="index" :matchType="val.category" :time="dateFormatMd(val.date)" :matchInfo="val.playing_team" :status="val.status" :guessing_result="val.guessing_result" :actual_result="val.actual_result" @guess="clickGuess(val.id,index)"></matchCard>
      <div style="text-align:center;">
        <button v-if="hasMore==true" style="border:none;background:#fff;border-radius:5px;padding:5px 15px;font-size:12px;opacity:0.6;" @click="more">显示更多</button>
      </div>
    </div>
    <!-- 用户信息 -->
    <div class="userMeg">
      <router-link :to="{ name: 'index' }" replace>
        <img src="./../../assets/back.png" style="width:4.4vw;margin-left:4vw;margin-top:5vw;">
      </router-link>
      <div>积分：<span>{{myScore}}</span></div>
      <div @click="toRank">排名：<span>{{myRank}}</span></div>
      <div>参与场数：<span>{{myRound}}</span></div>
      <img :src="userHeader" class="userHeader" style="margin-right:4vw;margin-top:2.3vw;" alt="">
    </div>

    <!-- 竞猜弹窗 -->
    <div class="guessBg" v-if="guessBgShow==true">
      <div class="back pos_abs" @click="guessBgShow=false">×</div>
      <img src="./../../assets/jcZI.png" class="pos_abs" style="width:76.1vw;left:12vw;top:29.6vw;" alt="">
      <div class="guessBox pos_abs">
        <img src="./../../assets/btnFJL.png" class="pos_abs" style="width:5.5vw;left:-1vw;top:29.6vw;" alt="">
        <ul class="auto">
          <li v-for="(value,key,index) in myRate" @click="guessSelect(key)" :key="index">
            <template v-if="key==1">
              <img src="./../../assets/gold.png"><span>{{value}}</span>
            </template>
            <template v-if="key==2">
              <img src="./../../assets/silver.png"><span>{{value}}</span>
            </template>
            <template v-if="key==3">
              <img src="./../../assets/copper.png"><span>{{value}}</span>
            </template>
            <template v-if="key==4">
              <img src="./../../assets/none.png"><span>{{value}}</span>
            </template>
            <img src="./../../assets/gou.png" v-if="selectedNum==key" class="gou pos_abs" alt="">
          </li>
        </ul>
        <div class="stepBox auto">投入积分：
          <van-stepper v-model="stepValue" step="10" min="10" max="50" disable-input />
        </div>
        <img src="./../../assets/btnDone.png" class="btnDone pos_abs" @click="btnDoneData" alt="">
        <div class="pos_abs" style="width: 50vw;left: 19vw;top: 62vw;height:13.7333vw;background:rgba(255,255,255,0.7);color:#000;text-align:center;line-height:13.7333vw;border-radius:1vw;" v-if="doneDataLoading">数据提交中····</div>
      </div>
    </div>

    <!-- 积分结算弹窗 -->
    <div class="mask pos_abs" v-if="jieSuanBgShow==true"></div>
    <div class="jieSuanBg pos_abs" v-if="jieSuanBgShow==true">
      <div class="yesterdayRound  pos_abs">11</div>
      <div class="yesterdayMark pos_abs">22</div>
      <img src="./../../assets/reDone.png" class="reDone pos_abs" alt="">
    </div>

  </div>
</template>
<script>
const testList = [
  {
    time: "12:00",
    matchType: "足球",
    title: "竞猜-胜",
    guessing_result: 1,
    actual_result: 1,
    matchInfo: "中国-巴西",
    status: 5,
  },
];
import calendarCard from "./components/calendarCard.vue";
import matchCard from "./components/matchCard.vue";
import { Stepper, Toast, PullRefresh } from "vant";
import { list, rate, guessing } from "@/apis/olympic";
import { getToken } from "./../common";
export default {
  components: { calendarCard, vanStepper: Stepper, matchCard },
  data() {
    return {
      userHeader: "",
      //竞猜弹窗
      guessBgShow: false,
      stepValue: 10, //投入积分
      selectedNum: 1, //选择的奖牌
      selectedRate: 0, //比率
      //结算弹窗
      jieSuanBgShow: false,
      testList,
      //竞猜list数据
      myRank: null,
      myScore: null,
      myRound: null,
      myList: [],
      hasMore: false,
      page: 1,
      listDataLoading: true,
      //竞猜赔率
      myRate: null,
      //提交数据
      postID: null,
      postIndex: null,
      postRate: null,
      doneDataLoading: false,
    };
  },
  created() {
    this.getListData(this.page);
    this.userHeader = getToken().avatar;
  },
  methods: {
    //获取列表数据
    getListData: function (page) {
      var _this = this;
      list(page).then((resp) => {
        var listData = resp.data.data.list;
        listData.map(function (item, index) {
          _this.myList.push(item);
        });

        this.hasMore = resp.data.data.has_more;
        if (resp.data.data.rank && resp.data.data.score) {
          this.myRank = resp.data.data.rank;
          this.myScore = resp.data.data.score;
        }
        if (resp.data.data.count) {
          this.myRound = resp.data.data.count;
        }
        this.listDataLoading = false;
        //console.log(resp);
      });
    },
    //点击单个列表
    clickGuess: function (id, index) {
      this.postID = id;
      this.postIndex = index;
      rate(id).then((resp) => {
        this.myRate = resp.data.data;
        this.guessBgShow = true;
        this.selectedNum = 1;
        this.stepValue = 10;
        this.postRate = this.myRate[1];
      });
    },
    //猜奖牌
    guessSelect: function (key) {
      this.selectedNum = key;
      this.postRate = this.myRate[key];
    },
    //提交数据
    btnDoneData: function () {
      var _this = this;
      if (this.myScore < this.stepValue) {
        Toast.fail("积分不足");
        return false;
      }
      this.doneDataLoading = true;
      guessing(
        this.postID, //id
        String(this.postRate), //magnify
        this.stepValue, //score
        Number(this.selectedNum) //guessing_result
      )
        .then((resp) => {
          if (resp.data.data && resp.data.data.id) {
            Toast.success("提交成功");
            _this.myList[_this.postIndex].guessing_result =
              resp.data.data.guessing_result;
            _this.myList[_this.postIndex].status = 2;
            _this.myScore = _this.myScore - resp.data.data.score;
            setTimeout(() => {
              _this.guessBgShow = false;
              _this.doneDataLoading = false;
              _this.postIndex = null;
              _this.selectedNum = 1;
              _this.stepValue = 10;
            }, 2000);
          } else {
            Toast.fail(resp.data.message);
            _this.doneDataLoading = false;
          }
        })
        .catch((resp) => {
          console.log(resp);
          // Promise.reject(resp);
        });
    },
    toRank: function () {
      this.$router.replace({
        name: "rank",
      });
    },
    dateFormatMd: function (str) {
      return str.substr(5, 11);
    },
    more: function () {
      this.page++;
      this.getListData(this.page);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../common.scss";

.userMeg {
  width: 100vw;
  height: 13.9vw;
  line-height: 13.9vw;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0px -3px 5px #33a727;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  z-index: 10;
  span {
    color: #ff3b64;
    font-weight: bold;
  }
}
.timelineTop {
  width: 100vw;
  height: 14.93vw;
  background: url(./../../assets/rankTop.jpg) no-repeat center top;
  background-size: 100% 100%;
  padding-top: 1px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
}
.userHeader {
  width: 9.3vw;
  height: 9.3vw;
  border-radius: 10vw;
}
.guessBg {
  background: rgba(0, 0, 0, 0.6);
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 11;
}
.guessBox {
  width: 88vw;
  height: 68vw;
  background: #fff;
  left: 4.5vw;
  top: 58.3vw;
  border-radius: 5px;
  border: 1.5vw solid #ffda29;
  ul {
    width: 84vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 6vw;
    li {
      width: 18.8vw;
      text-align: center;
      position: relative;
      img {
        width: 18.8vw;
        display: block;
        &.gou {
          width: 12vw;
          left: 8vw;
          top: 10vw;
        }
      }
      span {
        display: block;
        margin-top: 9vw;
      }
    }
  }

  .stepBox {
    width: 65vw;
    display: flex;
    flex-flow: row;
    margin-top: 5vw;
    font-size: 16px;
    font-weight: bold;
    line-height: 10vw;
    justify-content: space-around;
  }
}
.btnDone {
  width: 50vw;
  left: 19vw;
  top: 62vw;
}
.mask {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  top: 0;
}
.jieSuanBg {
  width: 100vw;
  height: 97.5vw;
  background: url(./../../assets/jieSuanBg.png) no-repeat center top;
  background-size: 100% 100%;
  left: 0;
  top: 30vw;
  .reDone {
    width: 50vw;
    left: 25vw;
    top: 90vw;
  }
  .yesterdayRound {
    width: 20vw;
    left: 51.3vw;
    top: 41.5vw;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
  }
  .yesterdayMark {
    width: 20vw;
    text-align: center;
    left: 38vw;
    top: 52vw;
    font-size: 22px;
    font-weight: bold;
  }
}
.listWrapper {
  margin-top: 1.93vw;
  padding: 3vw;
  box-sizing: border-box;
  margin-bottom: 13.9vw;
}
.back {
  width: 5vw;
  height: 5vw;
  border: 3px solid #fff;
  border-radius: 5vw;
  right: 12vw;
  top: 30.5vw;
  color: #fff;
  font-size: 5vw;
  display: flex;
  justify-content: center;
  align-content: center;
  font-weight: bold;
  z-index: 2;
  line-height: 5vw;
}
</style>
<style>
.van-stepper__minus,
.van-stepper__plus {
  background-color: #fff;
  border: 2px solid #000;
  border-radius: 4px;
  color: #000;
}
.van-stepper__minus--disabled,
.van-stepper__plus--disabled {
  background-color: #f7f8fa;
  border: 2px solid #dee0e4;
}
.van-stepper__input {
  background-color: transparent;
  border-bottom: 2px solid #000;
  width: 60px;
}
</style>